export default "/packs/images/carabiner-5~e7c760ad0f2a351498435358cc8c9647.png";